export default __webpack_public_path__ + "static/media/Camion8.858b9433.png";